import styled from 'styled-components';

import breakpoints, { under } from '@polyai/ui/styles/config/breakpoints';
import themeColors from '@polyai/ui/styles/config/colors';

/**
 * Container for LeftPanel with Next.js Image optimization.
 * Use with the LeftPanel React component.
 */
export const LeftPanelContainer = styled.div<{
  $backgroundColor?: string;
}>`
  position: relative;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${p => p.$backgroundColor || themeColors.background};

  @media ${under(breakpoints.sm)} {
    display: none;
  }
`;

/**
 * Blur overlay for LeftPanel background effect.
 * Used when CSS filter on the image isn't sufficient.
 */
export const BlurOverlay = styled.div`
  pointer-events: none;

  position: absolute;
  inset: 0;

  backdrop-filter: blur(8px);
`;

/**
 * Vignette overlay for LeftPanel.
 * Creates a subtle darkening effect at the edges.
 */
export const VignetteOverlay = styled.div`
  pointer-events: none;

  position: absolute;
  inset: 0;

  background: radial-gradient(
    120% 80% at 50% 50%,
    rgb(0 0 0 / 0%) 40%,
    rgb(0 0 0 / 25%) 70%,
    rgb(0 0 0 / 55%) 100%
  );
`;
